exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".UserSettingsModal{position:fixed;top:0;left:0;display:flex;justify-content:center;align-items:center;z-index:20;width:100vw;height:100vh;max-height:unset;background-color:#00000073}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/modals/UserSettingsModal/UserSettingsModal.scss
// module id = 1710
// module chunks = 0